// src/config.js
const config = {
    rootUrl: process.env.REACT_APP_ROOT_URL,
    // apiUrl: process.env.REACT_APP_API_URL,
    // anotherVar: process.env.REACT_APP_ANOTHER_VAR
};

export default config;